import React from 'react';
import ChartContent from './ChartContent';
import LineSelect from './LineSelect';
import { fetchListChart, REDUCER_NAME } from './reducer';
import { connect } from 'react-redux';
import Const from './Const';
import Loading from './../../../common/loading/Loading';
import { getUnique } from './../../../helpers/Common';
import { ChartFooter } from './../../../common/chart/footer';
import { LabelLeftRight } from '../../../common/chart/label';
import { Translate, I18n } from 'react-redux-i18n';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../../app/commonReducer';
import AutoReloadOnFocusBlurComponent from '../../../../core/loading/AutoReloadOnFocusBlur';

const MIN_WIDTH = 500;
const HEIGHT = 350;

class Chart extends AutoReloadOnFocusBlurComponent {
  constructor(props) {
    super(props);
    this.state = {
      keyChart: getUnique(),
      activeLines: {},
    };
  }

  reload() {
    const { dispatch } = this.props;
    dispatch(fetchListChart());
  }

  componentDidMount() {
    super.componentDidMount();
    const { dispatch } = this.props;
    dispatch(fetchListChart());
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (
      this.props.component !== nextProps.component ||
      this.props.data !== nextProps.data
    ) {
      this.setState({ keyChart: getUnique() });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  renderWithData = height => {
    const { activeLines } = this.state;
    const {
      data,
      rate,
      comGroupCode,
      listIndustryByKey,
      component,
      isFetching,
    } = this.props;

    const industry = { ...listIndustryByKey, ...Const.listComGroupCodeByKey }[
      comGroupCode
    ];

    const codeName = industry ? industry.icbName : '';

    const width = Math.max(component.width - 40, MIN_WIDTH);
    const heightFooter = 40;
    const heightHeader = 20;

    return (
      <div
        id="valuation-chart"
        className={`valuation-chart stock-chart position-relative`}
        style={{ width, height }}
      >
        <LineSelect
          onChange={this.onActiveLineChange}
          activeLines={activeLines}
        />
        {isFetching && <Loading />}
        <div className={isFetching ? 'bg-blur' : ''}>
          {data && data.length > 1 ? (
            <>
              <div className="position-relative">
                <LabelLeftRight
                  text={codeName + ' - ' + I18n.t('common.points')}
                />
                <LabelLeftRight
                  text={Const.listRateByKey[rate].name}
                  position={'right'}
                />
                <div style={{ height: heightHeader, fontWeight: 600 }}>
                  <Translate value={'marketInDepthValuation.chartTitle'} />
                </div>
                <div className="ml-20 mr-20">
                  <ChartContent
                    activeLines={activeLines}
                    key={this.state.keyChart}
                    data={data}
                    rate={rate}
                    codeName={codeName}
                    width={width - 60}
                    height={height - heightFooter - heightHeader}
                    ratio={window.devicePixelRatio}
                  />
                </div>
              </div>
              <ChartFooter
                list={[
                  { text: codeName, color: '#42b6f6', type: 'line' },
                  {
                    text: Const.listRateByKey[rate].name,
                    color: '#facc5c',
                    type: 'line',
                  },
                ]}
              />
            </>
          ) : (
            !isFetching && <Translate value={'common.NO_DATA'} />
          )}
        </div>
      </div>
    );
  };

  render() {
    return this.renderWithData(HEIGHT);
  }
}

const mapStateToProps = state => {
  return {
    data: state[REDUCER_NAME].listDataChart,
    rate: state[REDUCER_NAME].rate,
    comGroupCode: state[REDUCER_NAME].comGroupCode,
    listIndustryByKey: state[COMMON_REDUCER_NAME].listIndustryByIcbCode,
    component: state[REDUCER_NAME].component,
    isFetching: state[REDUCER_NAME].isFetching,
  };
};

export default connect(mapStateToProps)(Chart);
